module.exports = {
      id: "comm-lifestyle-usage",
      viewBox: "0 0 294 59.387",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-lifestyle",
      toString: function () {
        return this.url;
      }
    }